import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Checkbox,
  ListItemText,
  DialogContentText,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
});

class ProductsUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { handleClose, handleSubmit, classes, open, variants } = this.props;
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Update Products</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to update these products?
            <br />
            <br />
            The buyer will be notified of the update.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSubmit(variants)} className={classes.button}>
            Submit
          </Button>
          <Button onClick={() => handleClose()} className={classes.button}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ProductsUpdate.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
export default withStyles(styles)(ProductsUpdate);



// WEBPACK FOOTER //
// ./src/components/ProductsUpdate.jsx